var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breakdown-section"},[_c('div',{staticClass:"breakdown-chart"},[_c('SectionHeader',{attrs:{"title":_vm.name}}),_c('v-chart',{staticClass:"w-chart--breakdown",attrs:{"option":_vm.chartData,"autoresize":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }